import {
  CompleteFlexpaConsentRequestDto as GeneratedCompleteFlexpaConsentRequest,
  FlexpaConfigDto as GeneratedFlexpaConfig,
  FlexpaConnectionsDto as GeneratedFlexpaConnections,
  FlexpaConsentCompletionResultDto as GeneratedFlexpaConsentCompletion,
  FlexpaConsentStartDto as GeneratedFlexpaConsentStart,
  StartFlexpaConsentRequestDto as GeneratedStartFlexpaConsentRequest,
} from '@generated/models'

// Local aliases to generated API models to keep frontend types in sync with backend
export type CompleteFlexpaConsentRequest = GeneratedCompleteFlexpaConsentRequest
export type FlexpaConfig = GeneratedFlexpaConfig
export type FlexpaConnections = GeneratedFlexpaConnections
export type FlexpaConsentCompletion = GeneratedFlexpaConsentCompletion
export type FlexpaConsentStart = GeneratedFlexpaConsentStart
export type StartFlexpaConsentRequest = GeneratedStartFlexpaConsentRequest
export {FlexpaAuthorizationType} from '@generated/models'
export type {FlexpaConnection, FlexpaConnectionSource} from '@generated/models'
export {FlexpaConsentSessionMode as FlexpaConsentMode} from '@generated/models'
